import React from "react"
import {
    componentStyles,
    HorizontalStack,
    Image,
} from "@mallardbay/lib-react-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLocationDot } from "@fortawesome/free-solid-svg-icons/faLocationDot"

import DeerIcon from "~images/icons/deer.svg"
import FishIcon from "~images/icons/fish.svg"
import BlastCastIcon from "~images/icons/blast_cast.svg"
import { ListingType } from "~graphql/generated/graphql"
import type { Listing } from "~graphql/generated/graphql"
import type { TestId } from "~config/test-ids"

interface Props {
    readonly type?: Listing["type"]
    readonly testId?: TestId
    // lat and long is used by the map component
    // eslint-disable-next-line react/no-unused-prop-types
    readonly lat?: number
    // eslint-disable-next-line react/no-unused-prop-types
    readonly lng?: number
}

export default function TripMarker({ type, testId }: Props) {
    const styles = useStyles()
    const icon = getIcon(type)

    return (
        <HorizontalStack testId={testId} style={styles.root}>
            {icon ? (
                <Image src={DeerIcon} style={styles.image} />
            ) : (
                <FontAwesomeIcon icon={faLocationDot} fontSize={28} />
            )}
        </HorizontalStack>
    )
}

function useStyles() {
    return componentStyles({
        root: {
            justifyContent: "center",
            height: "120px",
            width: "120px",
            borderRadius: "full",
            backgroundColor: "rgba(0,0,0,0.1)",
            transform: "translate(-50%, -50%)", // Centers the marker otherwise the top left corner is the marker and it looks off
        },
        image: {
            width: "64px",
            height: "64px",
        },
    })
}

function getIcon(type: Listing["type"]) {
    switch (type) {
        case ListingType.Hunting:
            return DeerIcon
        case ListingType.Fishing:
            return FishIcon
        case ListingType.BlastCast:
            return BlastCastIcon
        default:
            return null
    }
}
